import React from 'react';
import { IconPropType } from '../../../Interfaces/IconPropType';
import { neutral } from '../../../style/colors';
export const Plus = (props: IconPropType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      onClick={onClick ? () => onClick() : () => { }}
      style={style}
      width={width ? width : height ? height : 16}
      height={height ? height : width ? width : 16}
      viewBox="0 0 13 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Screens"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="1---Filter---Farver-efter-anvendelse-1"
          transform="translate(-1187.000000, -495.000000)"
          fill={color ? color : neutral[600]}
        >
          <path
            d="M1193.37915,495.45377 C1196.69286,495.45377 1199.37915,498.140062 1199.37915,501.45377 C1199.37915,504.767479 1196.69286,507.45377 1193.37915,507.45377 C1190.06544,507.45377 1187.37915,504.767479 1187.37915,501.45377 C1187.37915,498.140062 1190.06544,495.45377 1193.37915,495.45377 Z M1193.71904,498.335538 L1192.95056,498.335538 C1192.79207,498.335538 1192.66239,498.465218 1192.66239,498.623715 L1192.66239,498.623715 L1192.66239,500.737011 L1190.54909,500.737011 C1190.39059,500.737011 1190.26091,500.866691 1190.26091,501.025188 L1190.26091,501.025188 L1190.26091,501.793659 C1190.26091,501.952157 1190.39059,502.081836 1190.54909,502.081836 L1190.54909,502.081836 L1192.66239,502.081836 L1192.66239,504.195133 C1192.66239,504.35363 1192.79207,504.483309 1192.95056,504.483309 L1192.95056,504.483309 L1193.71904,504.483309 C1193.87753,504.483309 1194.00721,504.35363 1194.00721,504.195133 L1194.00721,504.195133 L1194.00721,502.081836 L1196.12051,502.081836 C1196.27901,502.081836 1196.40869,501.952157 1196.40869,501.793659 L1196.40869,501.793659 L1196.40869,501.025188 C1196.40869,500.866691 1196.27901,500.737011 1196.12051,500.737011 L1196.12051,500.737011 L1194.00721,500.737011 L1194.00721,498.623715 C1194.00721,498.465218 1193.87753,498.335538 1193.71904,498.335538 L1193.71904,498.335538 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default Plus;
